export default "__VITE_ASSET__LhRWuboK__"